// Ъ2 — таблиците на С5, без заглавието и без тегленето на данни.
//
// Изнесени, защото същото се показва на две места: справката зад вход
// (ReportCross) и публичният линк.
//
// `showGrandTotal` — общият итог за целия обхват. През линка се СКРИВА:
// обхватът там е всички землища на фирмата, всяка замяна между две от тях
// отнема в едното и добавя в другото, и итогът излиза почти винаги нула.
// Вярно, но за земеделеца само объркващо — смисълът е по землища.

// С1: минус = търсеният ползвател дава. Показва се със знак по редовете,
// а в „ОБЩО" — само големината плюс думата ДАВА/ВЗЕМА, за да няма
// отрицателни числа в итога.
const цвятНаПосока = (посока) =>
    посока === "ДАВА" ? "var(--app-danger-fg)"
        : посока === "ВЗЕМА" ? "var(--app-success-fg)" : "inherit";

export const CrossView = ({data, showGrandTotal = true}) => (
    <>
            {data.sections.length === 0 && (
                <div className="alert alert-info">Няма замени за този обхват.</div>
            )}

            {data.sections.map(section => (
                <div key={section.settlement.ekatte} className="mb-4">
                    <h6 style={{color: "var(--app-gold)"}}>
                        Землище: {section.settlement.name} ({section.settlement.ekatte})
                    </h6>
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead className="tableHead">
                            <tr>
                                <th>Дава</th>
                                <th>Взема</th>
                                <th>От землище</th>
                                <th>В землище</th>
                                <th className="text-end">Сума (дка)</th>
                                <th className="text-end">Брой</th>
                            </tr>
                            </thead>
                            <tbody>
                            {section.rows.map((r, i) => (
                                <tr key={i}>
                                    <td>{r.company_giving}</td>
                                    <td>{r.company_receiving}</td>
                                    <td>{r.settlement_giving_name}</td>
                                    <td>{r.settlement_receiving_name}</td>
                                    <td className="text-end">
                                        {(r.signed_amount ?? r.amount).toFixed(2)}
                                    </td>
                                    <td className="text-end">{r.count}</td>
                                </tr>
                            ))}
                            </tbody>
                            <tfoot>
                            <tr className="fw-bold">
                                <td>
                                    ОБЩО —{" "}
                                    <span style={{color: цвятНаПосока(section.net_direction)}}>
                                        {section.net_direction}
                                    </span>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-end">
                                    {(section.net_abs ?? section.total).toFixed(2)}
                                </td>
                                <td></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            ))}

            {showGrandTotal && data.grand_net_direction && data.sections.length > 0 && (
                <div className="mt-3">
                    <div className="fw-bold" style={{fontSize: "1.1em"}}>
                        ОБЩО {data.scope.type === "settlement"
                            ? "в землището" : "в цялата община"}:{" "}
                        {data.grand_net_abs.toFixed(2)} —{" "}
                        <span style={{color: цвятНаПосока(data.grand_net_direction)}}>
                            {data.grand_net_direction}
                        </span>
                    </div>
                    {data.has_undetermined && (
                        <div className="mt-1" style={{fontSize: "0.95rem"}}>
                            <div>
                                от които в определени землища:{" "}
                                {data.named_net_abs.toFixed(2)} —{" "}
                                <span style={{color: цвятНаПосока(data.named_net_direction)}}>
                                    {data.named_net_direction}
                                </span>
                            </div>
                            <div>
                                все още в „неопределено":{" "}
                                {data.undetermined_net_abs.toFixed(2)} —{" "}
                                <span style={{color: цвятНаПосока(data.undetermined_net_direction)}}>
                                    {data.undetermined_net_direction}
                                </span>
                            </div>
                        </div>
                    )}
                    {data.scope.type !== "settlement" && (
                        <div className="text-muted" style={{fontSize: "0.9rem"}}>
                            Замяна изцяло вътре в общината се самоизяжда — отнема в
                            едното землище и добавя същото в другото. Затова общото
                            показва само каквото пресича границата на общината.
                        </div>
                    )}
                </div>
            )}
    </>
);
